<template>
  <v-flex xs12 sm8 md6 lg4>
    <v-form v-model="valid" lazy-validation
      ><v-text-field
        v-model="currentPassword"
        label="Current Password"
        autocomplete="current-password"
        :rules="[rules.required]"
        :append-icon="showCurrentPass ? 'visibility' : 'visibility_off'"
        :type="showCurrentPass ? 'text' : 'password'"
        @click:append="showCurrentPass = !showCurrentPass"
      ></v-text-field
      ><v-text-field
        v-model="newPassword"
        label="New Password"
        autocomplete="new-password"
        :rules="[rules.required]"
        :append-icon="showNewPass ? 'visibility' : 'visibility_off'"
        :type="showNewPass ? 'text' : 'password'"
        @click:append="showNewPass = !showNewPass"
      ></v-text-field>
      <v-text-field
        label="New Password Confirmation"
        autocomplete="new-password"
        :rules="[rules.required, rules.passwordConfirmation]"
        :append-icon="showNewPassConfirmation ? 'visibility' : 'visibility_off'"
        :type="showNewPassConfirmation ? 'text' : 'password'"
        @click:append="showNewPassConfirmation = !showNewPassConfirmation"
      ></v-text-field>
      <v-flex xs12>
        <span v-if="ex != null" class="red--text">{{ ex.message }}</span>
      </v-flex>
      <v-btn
        :loading="loading"
        color="primary"
        :disabled="!valid"
        @click="save"
      >
        Update
      </v-btn>
    </v-form>
  </v-flex>
</template>

<script>
import axios from 'axios'
import Constants from '../constants'
export default {
  name: 'UpdatePasswordPage',
  data() {
    return {
      currentPassword: null,
      newPassword: null,
      loading: false,
      valid: null,
      ex: null,
      rules: {
        required: (value) => {
          return !!value || 'Required!'
        },
        passwordConfirmation: (value) => {
          return value === this.newPassword || 'Passwords not matching!'
        }
      },
      showCurrentPass: false,
      showNewPass: false,
      showNewPassConfirmation: false
    }
  },
  methods: {
    save() {
      const url = `${Constants.CEZY_API_BASE_URL}/webapi/profile/update-password`
      this.loading = true
      axios
        .post(
          url,
          {
            currentPassword: this.currentPassword,
            newPassword: this.newPassword
          },
          {
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem('token')
            }
          }
        )
        .then((response) => {
          console.log(response)
          this.ex = null
          this.$notify({
            group: 'notifications',
            type: 'success',
            title: 'Success',
            text: 'Password updated successfully!'
          })
          this.$router.push('/')
        })
        .catch((ex) => {
          if (ex.response.status === 401) {
            // incorrect current password
            this.ex = {
              message: 'Incorrect current password!'
            }
          } else {
            this.ex = ex.response.data
          }

          console.log(ex.response)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
